import { BrowserRouter, useLocation, useNavigationType } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import Navbar from "./components/feature/Navbar";
import Footer from "./components/feature/Footer";
import { useEffect } from "react";
import { getStoredGA4Id } from "./hooks/useGA4";

/* ─── GA4 Tracker ─── */
function GA4Tracker() {
  const location = useLocation();
  const navType = useNavigationType();

  useEffect(() => {
    const measurementId = getStoredGA4Id();
    if (!measurementId) return;

    // Inject GA4 script once
    const scriptId = "ga4-script";
    if (!document.getElementById(scriptId)) {
      const scriptSrc = document.createElement("script");
      scriptSrc.id = scriptId;
      scriptSrc.async = true;
      scriptSrc.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
      document.head.appendChild(scriptSrc);

      const scriptInit = document.createElement("script");
      scriptInit.id = "ga4-init";
      scriptInit.textContent = [
        "window.dataLayer = window.dataLayer || [];",
        "function gtag(){dataLayer.push(arguments);}",
        "gtag('js', new Date());",
        `gtag('config', '${measurementId}', { send_page_view: false });`,
      ].join("\n");
      document.head.appendChild(scriptInit);
    }
  }, []);

  // Track page views on route change (skip admin)
  useEffect(() => {
    const measurementId = getStoredGA4Id();
    if (!measurementId) return;
    if (location.pathname.startsWith("/admin")) return;
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_title: document.title,
        page_location: window.location.href,
        page_path: location.pathname + location.search,
      });
    }
  }, [location, navType]);

  return null;
}

function Layout() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");

  return (
    <div className="min-h-screen flex flex-col">
      <GA4Tracker />
      {!isAdmin && <Navbar />}
      <main className="flex-1">
        <AppRoutes />
      </main>
      {!isAdmin && <Footer />}
    </div>
  );
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <Layout />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
